exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lupe-icon[data-v-00412b51]{width:20px}", ""]);

// exports
